import { useEffect, useState } from 'react';
import styles from './PopupModal.module.scss';
import Image from 'next/image';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getLatestPopup} from 'data/fetchPlugin';
// import probe from 'probe-image-size';

const SubscribeModal = (props) => {
  const [intiData, setIntiData] = useState({})
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true)

  useEffect(() => {
    let subscribe = true;
    (async () => {
      setLoading(true)
      const data = await getLatestPopup()
      setIntiData(p => ({...p, ...data}))
      setLoading(false)
    })()
    return () => {
      subscribe = false;
    };
  }, []);

  const onCloseModal = () => {
    setShow(!show)
  };

  const imageAttr = {
    className: styles.imageCustom,
    src: '',
    alt: "thumbnail",
  }

  return (
    <>
    {!loading && intiData?.thumbnail &&
      <div className={`${styles.wrapper} ${show ? styles.show : styles.hide}`}>
        <div className={styles.content}>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onCloseModal}
          >
            <FontAwesomeIcon icon={faTimes} size="sm" />
          </button>
          {intiData?.link ? <a href={intiData.link} target="_blank">
            <img
              {...{
                ...imageAttr,
                src: intiData.thumbnail
              }}
            />
          </a> :
          <div className={styles.imageContainer}>
            <img
              {...{
                ...imageAttr,
                src: intiData.thumbnail
              }}
            />
          </div>}
        </div>
      </div>
      }
    </>
  );
};

export default SubscribeModal;
